<a class="brand-link" *ngIf="useHref; else internalLink" [attr.href]="link"  [attr.target]="target"  [attr.title]="title" [attr.aria-label]="ariaLabel">
  <img class="brand-logo" [src]="src" [alt]="alt" [width]="width" [height]="height">
</a>

<ng-template #internalLink>
  <a class="brand-link" [routerLink]="link"  [attr.target]="target"  [attr.title]="title" [attr.aria-label]="ariaLabel">
    <img class="brand-logo" [src]="src" [alt]="alt" [width]="width" [height]="height">
  </a>
</ng-template>
